import React from 'react';
import { RouteObject } from 'react-router-dom';
import { AuditorMerchants } from './AuditorMerchants';
import { MerchantDetail } from './routes/MerchantDetail';
import { BranchDetail } from './routes/BranchDetail';

export const AuditorMerchantsRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        path: '',
        element: <AuditorMerchants />,
      }, {
        path: 'merchants/:id',
        element: <MerchantDetail />,
      }, {
        path: 'branches/:id',
        element: <BranchDetail />,
      },
    ],
  },
];
